"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8685],{

/***/ 61937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Footer/Column.tsx





var Title = function Title(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
    as: "h6",
    fontFamily: "Montserrat-SemiBold",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    lineHeight: "18px",
    letterSpacing: ".2px",
    color: "baseDark",
    mb: 2,
    children: children
  });
};

var FooterColumn = function FooterColumn(_ref2) {
  var title = _ref2.title,
      items = _ref2.items;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
    align: "flex-start",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: title
    }), items && items.map(function (child) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
        title: child.title,
        target: child.target,
        fontFamily: "Montserrat-Medium",
        fontSize: "0.875rem",
        lineHeight: "18px",
        letterSpacing: ".2px",
        color: "baseNeutral.700",
        href: child.href,
        children: child.name
      }, child.name);
    })]
  });
};

/* harmony default export */ var Column = (FooterColumn);
;// CONCATENATED MODULE: ./src/components/Footer/Desktop.tsx








var LogoImg = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Desktop__LogoImg",
  componentId: "sc-199nxhz-0"
})(["margin:50px auto auto;width:5rem;"]);

var FooterDesktop = function FooterDesktop(_ref) {
  var display = _ref.display,
      titleCol1 = _ref.titleCol1,
      col1 = _ref.col1,
      titleCol2 = _ref.titleCol2,
      col2 = _ref.col2,
      titleCol3 = _ref.titleCol3,
      col3 = _ref.col3,
      copyright = _ref.copyright;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
    display: display,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Container */.W2, {
      as: dist_index_esm/* Stack */.Kq,
      maxW: "6xl",
      py: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
        templateColumns: "1.4fr 1.4fr 0.8fr 0.8fr",
        spacing: 8,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol1,
          items: col1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol2,
          items: col2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol3,
          items: col3
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
            templateColumns: "repeat(4, 1fr)",
            spacing: "0.2rem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
              label: "Facebook",
              href: "https://www.facebook.com/carplannercom",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
              label: "Instagram",
              href: "https://www.instagram.com/carplanner_ita/",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
              label: "Linkedin",
              href: "https://www.linkedin.com/company/carplanner/",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
              label: "Twitter",
              href: "https://twitter.com/CarPlannerIT",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                color: "#1b4832"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://pledge1percent.org/",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImg, {
              src: "https://static1.carplanner.com/logos/Pledge1_ProudMember_Large.png",
              alt: "Pledge 1% member",
              loading: "lazy",
              decoding: "async",
              width: "89px",
              height: "80px"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      pb: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "0.625rem",
        color: "baseNeutral.700",
        textAlign: "center",
        children: copyright
      })
    })]
  });
};

/* harmony default export */ var Desktop = (FooterDesktop);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/Footer/MobileMenuItem.tsx





var MobileMenuItem = function MobileMenuItem(_ref) {
  var title = _ref.title,
      items = _ref.items;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    border: "0",
    borderBottom: "1px solid #dadde1",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
        p: "m",
        _hover: {
          background: 'none'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
          flex: "1",
          textAlign: "left",
          fontSize: "1rem",
          fontFamily: "Montserrat-SemiBold",
          textTransform: "uppercase",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      pb: 4,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
        align: "flex-start",
        children: items && items.map(function (child) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
            title: child.title,
            target: child.target,
            fontFamily: "Montserrat-Medium",
            fontSize: "0.875rem",
            lineHeight: "18px",
            letterSpacing: ".2px",
            color: "baseNeutral.700",
            href: child.href,
            children: child.name
          }, child.name);
        })
      })
    })]
  });
};

/* harmony default export */ var Footer_MobileMenuItem = (MobileMenuItem);
;// CONCATENATED MODULE: ./src/components/Footer/Mobile.tsx








var Mobile_LogoImg = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Mobile__LogoImg",
  componentId: "sc-c9gfy7-0"
})(["margin:20px auto auto;width:5rem;"]);

var FooterMobile = function FooterMobile(_ref) {
  var display = _ref.display,
      titleCol1 = _ref.titleCol1,
      col1 = _ref.col1,
      titleCol2 = _ref.titleCol2,
      col2 = _ref.col2,
      titleCol3 = _ref.titleCol3,
      col3 = _ref.col3,
      copyright = _ref.copyright;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
    mb: "9rem",
    display: display,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* Accordion */.UQ, {
      allowToggle: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol1,
        items: col1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol2,
        items: col2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol3,
        items: col3
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
      p: "6",
      textAlign: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
        label: "Facebook",
        href: "https://www.facebook.com/carplannercom",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
        label: "Instagram",
        href: "https://www.instagram.com/carplanner_ita/",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
        label: "Linkedin",
        href: "https://www.linkedin.com/company/carplanner/",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* SocialButton */.Z0, {
        label: "Twitter",
        href: "https://twitter.com/CarPlannerIT",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://pledge1percent.org/",
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Mobile_LogoImg, {
            src: "https://static1.carplanner.com/logos/Pledge1_ProudMember_Large.png",
            alt: "Pledge 1% member",
            loading: "lazy",
            decoding: "async",
            width: "89px",
            height: "80px"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
      px: "1rem",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "0.625rem",
        color: "baseNeutral.700",
        textAlign: "center",
        children: copyright
      })
    })]
  });
};

/* harmony default export */ var Mobile = (FooterMobile);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx








var Footer = function Footer(_ref) {
  var col1 = _ref.col1,
      col2 = _ref.col2,
      col3 = _ref.col3;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Mobile, {
      display: {
        base: 'block',
        md: 'none'
      },
      titleCol1: t('common:footerMobile.titleCol1'),
      col1: col1,
      titleCol2: t('common:footerMobile.titleCol2'),
      col2: col2,
      titleCol3: t('common:footerMobile.titleCol3'),
      col3: col3,
      copyright: t('common:footerMobile.copyright')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop, {
      display: {
        base: 'none',
        md: 'block'
      },
      titleCol1: t('common:footer.titleCol1'),
      col1: col1,
      titleCol2: t('common:footer.titleCol2'),
      col2: col2,
      titleCol3: t('common:footer.titleCol3'),
      col3: col3,
      copyright: t('common:footerMobile.copyright')
    })]
  });
};

/* harmony default export */ var components_Footer = (Footer);

/***/ })

}]);